import { render, staticRenderFns } from "./give-active-sell-detail.vue?vue&type=template&id=714ae343"
import script from "./give-active-sell-detail.vue?vue&type=script&lang=js"
export * from "./give-active-sell-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports